<template>
  <div class="text-xs-center ">
    <img :src="require('@/assets/images/JourneySoFar.png')" alt="Journey So Far" width="100%" style="max-width:621px" >   
  
  </div>
</template>

<style scoped>
</style>

<script>
import OurJourney from "./OurJourney.ts";
export default OurJourney;
</script>